import { createFileRoute, } from '@tanstack/react-router';
import { prop, } from 'remeda';
import { api, } from '../../../../api/Api.js';
import {} from '../../../../pages/therapist/imported/ImportedTherapistSearch.js';
export const Route = createFileRoute('/therapist/imported')({
    validateSearch(search) {
        if (typeof search.displayName === 'string') {
            return {
                displayName: search.displayName,
            };
        }
        return {};
    },
    loaderDeps: prop('search'),
    async loader({ deps: search }) {
        return await api.therapist.imported.search.request(search);
    },
});
//# sourceMappingURL=route.js.map